<template>
  <div
    class="rt-date-picker"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false"
  >
    <el-date-picker
      ref="input"
      :value="inputValue"
      v-bind="$attrs"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      @input="inputHandler"
    ></el-date-picker>
    <rt-icon
      v-show="!showClose && !disabled"
      name="rt-base-date"
      @click="inputFocus"
    />
    <rt-icon v-if="showClose" name="rt-base-close" @click="clear" />
  </div>
</template>

<script>
import inputFocusMixins from './inputFocusMixins.js';
console.log(inputFocusMixins);
export default {
  name: 'RtDatePicker',
  mixins: [inputFocusMixins],
  props: {
    value: {
      type: [Date, String]
    },
    type: {
      type: String,
      default: 'date'
    },
    datafieldname: String,
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    placeholder: {
      type: String,
      default() {
        return this.$tx('请选择', 'xpc.lookup.placeholder');
      }
    }
  },
  data() {
    return {
      inputValue: null,
      inputHovering: true
    };
  },
  computed: {
    showClose() {
      return (
        !this.disabled &&
        this.inputValue &&
        this.inputHovering &&
        !this.readonly
      );
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.inputValue = new Date(newVal);
      } else {
        this.inputValue = null;
      }
    }
  },
  created: function() {
    if (this.value) {
      this.inputValue = new Date(this.value);
    }
  },
  methods: {
    // inputHandler(newValue) {
    //   this.inputValue = newValue;
    //   this.$emit('input', newValue, null, this.datafieldname);
    // },
    // clear() {
    //   this.$emit('input', '', null, this.datafieldname);
    // }

    inputHandler(newValue) {
      this.inputValue = newValue;
      this.$emit('input', newValue, null, this.datafieldname);
      this.$emit('change', newValue, null, this.datafieldname);
    },
    clear() {
      this.$emit('input', '', null, this.datafieldname);
      this.$emit('change', '', null, this.datafieldname);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDatePicker.vue?6d59a7b7